var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "racing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.743,
    height: 18.256,
    viewBox: "0 0 21.743 18.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1718",
    "data-name": "Grupo 1718",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1717",
    "data-name": "Grupo 1717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_632",
    "data-name": "Trazado 632",
    d: "M12.468,37.6H3.9a.693.693,0,1,0,0,1.387H7.56a9.306,9.306,0,0,0-2.067,1.733H.7a.693.693,0,1,0,0,1.387H4.473A8.989,8.989,0,0,0,4.9,52h-2a.693.693,0,1,0,0,1.387H6.129A9.317,9.317,0,0,0,7.56,54.469H.777a.693.693,0,1,0,0,1.387H12.468a9.129,9.129,0,1,0,0-18.256Zm0,16.869a7.742,7.742,0,1,1,7.866-7.741A7.813,7.813,0,0,1,12.468,54.469Z",
    transform: "translate(0 -37.6)",
    fill: "#ff4e4e"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1720",
    "data-name": "Grupo 1720",
    transform: "translate(6.02 2.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1719",
    "data-name": "Grupo 1719",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_633",
    "data-name": "Trazado 633",
    d: "M164.39,120.507a6.281,6.281,0,0,0-3.737,11.332c.014.012.028.024.043.035s.035.024.053.035a6.271,6.271,0,0,0,7.282,0q.027-.016.053-.035c.015-.011.029-.023.043-.035a6.281,6.281,0,0,0-3.737-11.332Zm.769,1.6a4.758,4.758,0,0,1,3.445,2.5l-1.992.647a2.71,2.71,0,0,0-1.453-1.057v-2.094Zm.392,4.682a1.161,1.161,0,1,1-1.161-1.161A1.163,1.163,0,0,1,165.552,126.79Zm-1.931-4.682V124.2a2.71,2.71,0,0,0-1.453,1.057l-1.992-.647A4.758,4.758,0,0,1,163.621,122.108Zm-2.6,8.016a4.742,4.742,0,0,1-1.318-4.049l1.993.647c0,.023,0,.045,0,.068a2.686,2.686,0,0,0,.557,1.64Zm3.373,1.411a4.715,4.715,0,0,1-2.129-.505l1.231-1.694a2.693,2.693,0,0,0,1.8,0l1.231,1.694A4.716,4.716,0,0,1,164.39,131.535Zm3.373-1.411-1.23-1.693a2.686,2.686,0,0,0,.557-1.64c0-.023,0-.045,0-.068l1.993-.647a4.742,4.742,0,0,1-1.318,4.049Z",
    transform: "translate(-158.107 -120.507)",
    fill: "#ff4e4e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.888b5d203586be28b24c6fe40c372d6c.svg";
export { ForwardRef as ReactComponent };